<template>
  <base-view>
    <view-section>
      <div v-if="!section">
        <p>Loading...</p>
      </div>
      <div v-else>
        <h1 class="mb-8 text-4xl font-semibold">{{ section.name }}</h1>
        <div class="overflow-hidden rounded-lg shadow-lg">
          <h2 class="p-4 m-0 text-white bg-primary">All Articles</h2>

          <template v-if="section.subsections">
            <a
              v-for="article in section.ungroupedArticles"
              :href="`/support/articles/${article.id}`"
              :key="article.id"
              class="flex items-center p-4 border-0 border-b border-neutral border-solid hover:bg-neutral-light active:bg-neutral"
            >
              <span class="flex-1">{{ article.name }}</span>
              <span
                v-if="article.promoted"
                class="ml-2 px-2 py-0.5 text-xs font-semibold text-white bg-primary rounded-full"
                >★ Featured</span
              >
            </a>

            <template v-for="subsection in section.subsections">
              <h3
                :key="subsection.name + '-header'"
                class="px-4 py-2 m-0 text-sm font-semibold tracking-wide uppercase text-primary bg-primary-50 border-b border-neutral"
              >
                {{ subsection.name }}
              </h3>
              <a
                v-for="article in subsection.articles"
                :href="`/support/articles/${article.id}`"
                :key="article.id"
                class="flex items-center p-4 border-0 border-b border-neutral border-solid hover:bg-neutral-light active:bg-neutral"
              >
                <span class="flex-1">{{ article.name }}</span>
                <span
                  v-if="article.promoted"
                  class="ml-2 px-2 py-0.5 text-xs font-semibold text-white bg-primary rounded-full"
                  >★ Featured</span
                >
              </a>
            </template>
          </template>

          <template v-else>
            <a
              v-for="article in section.articles"
              :href="`/support/articles/${article.id}`"
              :key="article.id"
              class="flex items-center p-4 border-0 border-b border-neutral border-solid last:border-b-0 hover:bg-neutral-light active:bg-neutral"
            >
              <span class="flex-1">{{ article.name }}</span>
              <span
                v-if="article.promoted"
                class="ml-2 px-2 py-0.5 text-xs font-semibold text-white bg-primary rounded-full"
                >★ Featured</span
              >
            </a>
          </template>
        </div>
      </div>
    </view-section>
  </base-view>
</template>

<script>
import BaseView from "@/components/layout/BaseView.vue";
import ViewSection from "@/components/layout/ViewSection.vue";

export default {
  name: "Section",
  components: {
    BaseView,
    ViewSection
  },
  data() {
    return {
      sectionId: parseInt(this.$route.params.sectionId)
    };
  },
  computed: {
    section() {
      return this.$store.getters.sectionById(this.sectionId);
    }
  }
};
</script>
